import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Media',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M16.5 23.5h-15v-17h15v17zm-2-15h-11v9h11v-9zm2 10.3l4.9.6 2.1-16.9L8.6.6l-.8 5.9m8.7 6.2l3.6.4 1.1-8.9-10.9-1.3-.5 3.6" }
      }), h("path", {
        attrs: { fill: "currentColor", d: "M15 22H3v-2h12v2zm1.5-4.8l3.5.4.2-2-3.8-.5M7 14.7v-3.4c0-.1.2-.2.3-.2l3.4 1.7c.1.1.1.3 0 .4l-3.4 1.7c-.1 0-.3-.1-.3-.2z" }
      })]
    );
  }
};